<template>
	<div v-wechat-title="this.contentarr.title+' 图片版'">
		<Header>
			<div class="leftcss"><a @click='goBack'><i class="iconfont icon---"></i></a></div>
			<div class="centercss"><router-link :to="'/daozang'+this.contentarr.nid+'-'+this.$route.params.id">{{contentarr.title}}</router-link></div>
		</Header>

		<div class="body-main">
	
	<div class=tudh1><input ref="changep" class="ctuinput" :value="cpage" v-on:change='changepage'  /><span class="ctuspan">/ {{sum}}</span>
	 <span class="ctuspan" v-on:click='shouye()'>首页</span><span class="ctuspan" v-on:click='moye()'>末页</span><span class="ctuspan" v-on:click='pageup()'>上页</span><span class="ctuspan" v-on:click='pagedown()'>下页</span></div>		
			
			
			<div class="mulu">
				<img id="zhutu" class="tu" :src="getPicture()" />
			</div>
		</div>
		<GoTop />
	</div>
</template>

<script>
	// @ is an alias to /src
	import Header from '@/components/Headertu.vue'
	import GoTop from '@/components/gotop.vue'
	import axios from 'axios'
	export default {
	 
		data() {
		
			return {
				sum:"",
				cpage:1,
				 
				showModal: false,
					contentarr: [],
			}
		},
		components: {
			Header,
			GoTop
		},
		mounted() {
			this.getsum(); 
			this.getcontent();
		 
		},

		methods: {
			goBack() {
				window.history.length > 1 ?
					this.$router.go(-1) :
					this.$router.push('/')
			},
			getPicture(){
          return  'https://www.daorenjia.com/ytu/'+this.$route.params.id+'/' + this.cpage + ".jpg"
      },
	  shouye(){
	  	 this.cpage=1;
	  
	  },
	  
			moye(){
				 this.cpage=this.sum;
			 
			},
			pageup(){
				 if( this.cpage>1)
				 this.cpage --;
				 
			 
			},
			pagedown(){
				 if( this.cpage<this.sum)
				 this.cpage ++;
				
			 
			},
		
				getsum(){
				//this.sum = 10;
				
				var _sself = this;
				axios.get('https://www.daorenjia.com/api/tuapi.php?id=' + this.$route.params.id).then(function(response) {
					// console.log(response);
					// _sself.sum = 10;
					_sself.sum = response.data;
				})
			},
			changepage(){
				
			  this.cpage=this.$refs.changep.value;
			 
			},
			getcontent: function() {
				var ___self = this;
				axios.get('https://m.daorenjia.com/api/tuneirongapi.php?id=' + this.$route.params.id).then(function(response) {
					// console.log(response);
					___self.contentarr = response.data;
				})
			},
		}
	}
</script>
 